import * as React from "react";
import { Pagination, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput } from 'react-admin';

const userFilters = [
    <TextInput source="email" label="Rechercher par email" alwaysOn />,
    <TextInput source="id" label="Rechercher par ID" alwaysOn />
];

export const UserList = props => (
    <List exporter={false} filters={userFilters} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <span style={{ color: 'purple' }}>A FAIRE</span>
            <EmailField source="email" />
            <span style={{ color: 'purple' }}>A FAIRE</span>
            <span style={{ color: 'purple' }}>A FAIRE</span>
            <TextField source="creationDate" />
        </Datagrid>
    </List>
);